import { render } from "./UpdateOrgForm.vue?vue&type=template&id=29c2c800&scoped=true"
import script from "./UpdateOrgForm.vue?vue&type=script&lang=js"
export * from "./UpdateOrgForm.vue?vue&type=script&lang=js"

import "./UpdateOrgForm.vue?vue&type=style&index=0&id=29c2c800&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c2c800"]])

export default __exports__